"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
function MovementDialog(props) {
    var modalState = props.modalState, setModalState = props.setModalState;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_1.useState)(""), batchNumber = _a[0], setBatchNumber = _a[1];
    var _b = (0, react_1.useState)(""), stockNumber = _b[0], setStockNumber = _b[1];
    var _c = (0, react_1.useState)(""), serialNumber = _c[0], setSerialNumber = _c[1];
    var _d = (0, react_1.useState)(""), assetNumber = _d[0], setAssetNumber = _d[1];
    var submitForm = function () {
        if (props.warehouseId &&
            batchNumber.length !== 0 &&
            stockNumber.length === 0 &&
            serialNumber.length === 0 &&
            assetNumber.length === 0) {
            navigate("/warehouses/".concat(props.warehouseId, "/batchMovements/").concat(batchNumber.trim()));
            setModalState(false);
        }
        else if (!props.warehouseId &&
            batchNumber.length !== 0 &&
            stockNumber.length === 0 &&
            serialNumber.length === 0 &&
            assetNumber.length === 0) {
            navigate("/warehouses/batchMovements/".concat(batchNumber.trim()));
            setModalState(false);
        }
        else if (props.warehouseId &&
            stockNumber.length !== 0 &&
            batchNumber.length === 0 &&
            serialNumber.length === 0 &&
            assetNumber.length === 0) {
            navigate("/warehouses/".concat(props.warehouseId, "/stockMovements/").concat(stockNumber.trim()));
            setModalState(false);
        }
        else if (!props.warehouseId &&
            stockNumber.length !== 0 &&
            batchNumber.length === 0 &&
            serialNumber.length === 0 &&
            assetNumber.length === 0) {
            navigate("/warehouses/stockMovements/".concat(stockNumber.trim()));
            setModalState(false);
        }
        else if (props.warehouseId &&
            serialNumber.length !== 0 &&
            stockNumber.length === 0 &&
            batchNumber.length === 0 &&
            assetNumber.length === 0) {
            navigate("/warehouses/".concat(props.warehouseId, "/serialMovements/").concat(serialNumber.trim()));
            setModalState(false);
        }
        else if (!props.warehouseId &&
            serialNumber.length !== 0 &&
            stockNumber.length === 0 &&
            batchNumber.length === 0 &&
            assetNumber.length === 0) {
            navigate("/warehouses/serialMovements/".concat(serialNumber.trim()));
            setModalState(false);
        }
        else if (props.warehouseId &&
            assetNumber.length !== 0 &&
            stockNumber.length === 0 &&
            serialNumber.length === 0 &&
            batchNumber.length === 0) {
            navigate("/warehouses/".concat(props.warehouseId, "/assetMovements/").concat(assetNumber.trim()));
            setModalState(false);
        }
        else if (!props.warehouseId &&
            assetNumber.length !== 0 &&
            stockNumber.length === 0 &&
            serialNumber.length === 0 &&
            batchNumber.length === 0) {
            navigate("/warehouses/assetMovements/".concat(assetNumber.trim()));
            setModalState(false);
        }
        else {
            antd_1.message.error(t("alerts.youCanSearchByOnlyOneNumber"));
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(antd_1.Modal, __assign({ title: t("warehouse.typeOneOfTheFollowingNumbersToSeeRelatedProductMovements"), open: modalState, onOk: submitForm, onCancel: function () { return setModalState(false); }, okButtonProps: {
                disabled: stockNumber.trim() === "",
            } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: t("warehouse.stockNumber") }), (0, jsx_runtime_1.jsx)(antd_1.Input, { value: stockNumber, onChange: function (e) { return setStockNumber(e.target.value); } })] })) }));
}
exports.default = MovementDialog;
